/** Shared type guard for P2P handoff parsers (untrusted JSON). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
